"use client";
import Link from "next/link";
import React, { useState } from "react";

export default function SearchParts({ parts }) {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredParts = searchTerm
    ? parts.filter(
        (part) =>
          part.partNo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          part.description?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : parts;

  return (
    <div className="parts-search">
      <input
        type="text"
        placeholder="Search by part number or description"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
        style={{
          width: "100%",
          padding: "0.75rem 1rem",
          fontSize: "1rem",
          border: "1px solid #ccc",
          borderRadius: "4px",
          marginBottom: "1.5rem",
        }}
      />
      <div className="parts-list">
        {filteredParts.length === 0 && (
          <p style={{ textAlign: "center", padding: "2rem" }}>
            No parts found for &quot;{searchTerm}&quot;.
          </p>
        )}
        <ul style={{ listStyle: "none", padding: 0 }}>
          {filteredParts.slice(0, 100).map((part) => (
            <li key={part.partNo} style={{ marginBottom: "0.5rem" }}>
              <Link
                href={`/parts/${part.partNo}`}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0.75rem 1rem",
                  border: "1px solid #eee",
                  borderRadius: "4px",
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <div>
                  <strong>{part.partNo}</strong>
                  {part.description && (
                    <span style={{ marginLeft: "1rem", color: "#666" }}>
                      {part.description}
                    </span>
                  )}
                </div>
                <span style={{ color: "#333", fontWeight: "500" }}>
                  View Part →
                </span>
              </Link>
            </li>
          ))}
        </ul>
        {filteredParts.length > 100 && (
          <p style={{ textAlign: "center", color: "#666", padding: "1rem" }}>
            Showing first 100 of {filteredParts.length} results. Refine your
            search to see more.
          </p>
        )}
      </div>
    </div>
  );
}
